import React from 'react'

import { SurgicalOrderDetailsLayout } from 'presentation/secretary/layouts/SurgicalOrderDetails'

export const SurgicalOrderDetails = () => {
  return <SurgicalOrderDetailsLayout />
}
